export default __webpack_public_path__ + "static/media/beach-ball.3886a103.png";